{
  "settings": {
    "title": "Paramètres du compte",
    "subtitle": "Gérez votre e-mail, votre mot de passe et l'état de votre compte.",
    "needHelp": "Besoin d'aide ? Rejoignez notre Discord"
  },
  "changeEmail": {
    "title": "Changer l'adresse e-mail",
    "subtitle": "Changer votre e-mail nécessitera de reconfirmer votre adresse e-mail. Vous serez déconnecté de toutes les sessions.",
    "newEmailLabel": "Nouvelle adresse e-mail",
    "newEmailPlaceholder": "Entrez le nouvel e-mail",
    "currentPasswordLabel": "Mot de passe actuel",
    "currentPasswordPlaceholder": "Entrez le mot de passe actuel",
    "submitButton": "Mettre à jour l'adresse e-mail",
    "submittingButton": "Mise à jour..."
  },
  "changePassword": {
    "title": "Changer le mot de passe",
    "subtitle": "Mettez à jour votre mot de passe. Vous resterez connecté sur cet appareil.",
    "currentPasswordLabel": "Mot de passe actuel",
    "currentPasswordPlaceholder": "Entrez le mot de passe actuel",
    "newPasswordLabel": "Nouveau mot de passe",
    "newPasswordPlaceholder": "Entrez le nouveau mot de passe",
    "confirmPasswordLabel": "Confirmer le nouveau mot de passe",
    "confirmPasswordPlaceholder": "Confirmez le nouveau mot de passe",
    "submitButton": "Changer le mot de passe",
    "submittingButton": "Mise à jour..."
  },
  "closeAccount": {
    "title": "Fermer le compte",
    "subtitle": "Désactivez définitivement votre compte. Si vous avez un abonnement actif, il sera annulé. Cette action ne peut pas être facilement annulée.",
    "openButton": "Je veux fermer mon compte",
    "warning": "⚠️ Avertissement : Cela désactivera votre compte, annulera tout abonnement actif, vous déconnectera de toutes les sessions et nous ne rembourserons pas les abonnements annulés. Vos données seront conservées mais votre compte sera inaccessible.",
    "passwordLabel": "Votre mot de passe",
    "passwordPlaceholder": "Entrez votre mot de passe",
    "confirmLabel": "Tapez",
    "confirmCode": "FERMER MON COMPTE",
    "confirmLabelEnd": "pour confirmer",
    "confirmPlaceholder": "FERMER MON COMPTE",
    "cancelButton": "Annuler",
    "submitButton": "Fermer le compte définitivement",
    "submittingButton": "Fermeture..."
  },
  "contactUs": {
    "title": "Nous contacter",
    "body": "Contactez-nous à",
    "discordName": "Discord Flipping Pal",
    "bodyEnd": "ou rejoignez notre communauté Discord pour toute question."
  }
}
